import _ from 'lodash';

/**
 * Flattens the study upload-status object into the ordered rows the upload status modal lists. Assigns a display title onto each of the pending events, ECG data, sensor data and other data entries and returns them as an array in that order.
 *
 * @param data - Upload status object holding the four upload sections.
 * @returns The four upload status entries, each carrying a title.
 */
const convertToArray = (data: any) => [
  _.assign(data.uploadPendingEvents, { title: 'Upload pending events' }),
  _.assign(data.uploadEcgData, { title: 'Upload ECG data' }),
  _.assign(data.uploadSensorData, { title: 'Upload sensor data' }),
  _.assign(data.uploadOtherData, { title: 'Upload other data' }),
];

export { convertToArray };
